import { PayloadAction } from '@reduxjs/toolkit'
import {
  all, call, put, takeLatest,
} from 'redux-saga/effects'
import { actions as appActions } from '../state'
import { actions } from './BasicQueriesState'
import {
  GetAddressByBatchParams, GetAddressDetailParams, GetBatchDetailParams, GetProductBatchDetailParams,
} from './BasicQueriesTypes'
import apis from './BasicQueriesApi'
import { ReturnCall } from '../types'
import { toast } from 'react-toastify'

export function* getAddressByBatch({ payload: { batch } }: PayloadAction<GetAddressByBatchParams>) {
  yield put(appActions.isLoading(true))

  try {
    const result: ReturnCall<typeof apis.getAddressByBatch> = yield call(
      apis.getAddressByBatch,
      { batch },
    )

    if (!result.isOk) {
      toast.error(result?.data?.data?.message || 'Falha ao buscar informações do lote informado!')
      return
    }

    yield put(actions.setBatchInfo(result.data))
  } catch (error: any) {
    toast.error('Falha ao buscar informações do lote informado!')
  } finally {
    yield put(appActions.isLoading(false))
  }
}

export function* getBatchDetail({ payload: { batch, address } }: PayloadAction<GetBatchDetailParams>) {
  yield put(appActions.isLoading(true))

  try {
    const result: ReturnCall<typeof apis.getBatchDetail> = yield call(
      apis.getBatchDetail,
      { batch, address },
    )

    if (!result.isOk) {
      toast.error(result?.data?.data?.message || 'Falha ao buscar informações do endereço informado!')
      return
    }

    yield put(actions.setBatchDetail(result.data))
  } catch (error: any) {
    toast.error('Falha ao buscar informações do endereço informado!')
  } finally {
    yield put(appActions.isLoading(false))
  }
}

export function* getAddressInfo({ payload }: PayloadAction<string>) {
  yield put(appActions.isLoading(true))

  try {
    const result: ReturnCall<typeof apis.getAddressInfo> = yield call(
      apis.getAddressInfo,
      payload,
    )

    if (!result.isOk) {
      toast.error(result?.data?.data?.message || 'Falha ao buscar informações do endereço informado!')
      return
    }

    yield put(actions.setAddressInfo({ productList: result.data, address: payload }))
  } catch (error: any) {
    toast.error('Falha ao buscar informações do endereço informado!')
  } finally {
    yield put(appActions.isLoading(false))
  }
}

export function* getProductInfoByBarcode({ payload }: PayloadAction<string>) {
  yield put(appActions.isLoading(true))

  try {
    const result: ReturnCall<typeof apis.getProductInfoByBarcode> = yield call(
      apis.getProductInfoByBarcode,
      payload,
    )

    if (!result.isOk) {
      toast.error(result?.data?.data?.message || 'Falha ao buscar informações do produto informado!')
      return
    }

    yield put(actions.setProductBatchInfo({ ...result.data, barcode: payload }))
  } catch (error: any) {
    toast.error('Falha ao buscar informações do produto informado!')
  } finally {
    yield put(appActions.isLoading(false))
  }
}

export function* getProductDetail({ payload: { barcode, address } }: PayloadAction<GetProductBatchDetailParams>) {
  yield put(appActions.isLoading(true))

  try {
    const result: ReturnCall<typeof apis.getBatchDetail> = yield call(
      apis.getBatchDetail,
      { batch: barcode, address },
    )

    if (!result.isOk) {
      toast.error(result?.data?.data?.message || 'Falha ao buscar informações do produto informado!')
      return
    }

    yield put(actions.setProductBatchDetail(result.data))
  } catch (error: any) {
    toast.error('Falha ao buscar informações do produto informado!')
  } finally {
    yield put(appActions.isLoading(false))
  }
}

export function* getAddressDetail({ payload: { product, address } }: PayloadAction<GetAddressDetailParams>) {
  yield put(appActions.isLoading(true))

  try {
    const result: ReturnCall<typeof apis.getBatchDetail> = yield call(
      apis.getBatchDetail,
      { batch: product, address },
    )

    if (!result.isOk) {
      toast.error(result?.data?.data?.message || 'Falha ao buscar informações do produto informado!')
      return
    }

    yield put(actions.setAddressDetail(result.data))
  } catch (error: any) {
    toast.error('Falha ao buscar informações do produto informado!')
  } finally {
    yield put(appActions.isLoading(false))
  }
}

export default function* () {
  yield all([
    takeLatest(actions.getAddressByBatch.type, getAddressByBatch),
    takeLatest(actions.getBatchDetail.type, getBatchDetail),
    takeLatest(actions.getAddressInfo.type, getAddressInfo),
    takeLatest(actions.getAddressDetail.type, getAddressDetail),
    takeLatest(actions.getProductDetail.type, getProductDetail),
    takeLatest(actions.getProductInfoByBarcode.type, getProductInfoByBarcode),
  ])
}
